import Image, { ImageProps } from 'next/image';

import { cn } from '../_utils/cn';

export const LogoSlot = ({
	logoUrl,
	imageProps,
	className,
}: {
	logoUrl: string;
	imageProps?: ImageProps;
	className?: string;
}) => {
	return (
		logoUrl && (
			<div className={cn('flex w-[30px] flex-none items-center', className)}>
				<Image
					src={logoUrl}
					height='34'
					width='30'
					className={'size-full object-contain object-center'}
					alt='Tralent Partner'
					{...imageProps}
				/>
			</div>
		)
	);
};
